$(document).ready(function($){
  // nav-item animation
  let tl1 = gsap.timeline({delay: .2});
  tl1.from(".mobile-nav > li",{
    opacity: 0,
    x: -100,
    stagger: .2
  });
  tl1.pause();  
  $(".js-mobile-nav-toggle").click(function(){
    tl1.play();
  });
  $(".closemmn").click(function(){
    tl1.reverse();
  });
  //end

  // collection list animation
  let cardWrapper = $(".anim-card__wrapper");
  cardWrapper.each((i, wrapper)=>{
    gsap.from($(wrapper).find(".anim-card"), {
      scrollTrigger:{
        trigger: wrapper,
        start: "top 80%",
        end:"top 70%",
        toggleActions: "play none none none",
        onEnter: ()=>{
          // console.log("Visible cards");
        }
      },
      opacity: 0,
      y:100,
      stagger: .2
    })
  });
  // end

  // For single product page current variant should be highlighted
  if($('.related-product')){
    let currentUrl = window.location.href;
    let relatedProductsUrl = $('.related-product');
  
    relatedProductsUrl.each((i, prod)=>{
      if(currentUrl == prod.href){
        $(prod).css("border-color", "black");
      }
    });    
  }
  // end

  // Smooth scrolling when clicking on anchor #
  $(document).on('click', 'a[href^="#"]', function (event) {
    let secID = $.trim($(this).attr('href'));
    event.preventDefault();  
    // Check if the target element exists
    if ($(secID).length) {
      $('html, body').animate({
        scrollTop: $(secID).offset().top - 150
      }, 500);
    } else {
      console.warn("Section ID does not exist:", secID);
    }
  });
  // End


  // initialize slider for card details card only for mobile
  if($('.cards-details__slider > .cards-details__cards').length && window.innerWidth < 766){
    var flkty = new Flickity('.cards-details__slider > .cards-details__cards', {
        cellAlign: 'left',
        groupCells: true,
        wrapAround: true,
        pageDots: true,
        prevNextButtons: false,
        autoPlay: false
      });
  }
  // end

  if($('.logo-bar-slider').length){

    let marqueeSlider = document.querySelector('.logo-bar-slider > .grid');
    let marqueeSlide = document.querySelector('.logo-bar-slider > .grid .gitem');
    let mainTicker = new Flickity('.logo-bar-slider > .grid', {
      accessibility: true,
      resize: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      percentPosition: true,
      setGallerySize: true,
    });
    
    // Set initial position to be 0
    mainTicker.x = 0;
    
    // Start the marquee animation
    play();
    
    // Main function that 'plays' the marquee.
    function play() {
      // Set the decrement of position x
      mainTicker.x -= .5;
    
      // Settle position into the slider
      mainTicker.settle(mainTicker.x);
    
      // Set the requestId to the local variable
      requestId = window.requestAnimationFrame(play);
    }
    
    // Main function to cancel the animation.
    function pause() {
      if(requestId) {
        // Cancel the animation
        window.cancelAnimationFrame(requestId)
    
        // Reset the requestId for the next animation.
        requestId = undefined;
      }
    }
    
    // Pause on hover/focus
    marqueeSlider.addEventListener('mouseenter', () => pause());
    
    // Unpause on mouse out / defocus
    marqueeSlider.addEventListener('mouseleave', () => play());
    
  }

  // changing position of whatsapp cta when scroll on pdp
  $(window).on('scroll', function() {
    if ($(window).scrollTop() > 600 && $('.shopify-whatsApp').length && $(".stickyCart").length) {
      $('.shopify-whatsApp').addClass('scrolled');
      $('#site-scroll').addClass('scrolled');
    } else {
      $('.shopify-whatsApp').removeClass('scrolled');
      $('#site-scroll').removeClass('scrolled');
    }
  });
  // end
  
  // added inline style for review widget on pdp
  let interval = setInterval(function () {
    const $el = $('.product-single__meta [id*="areviews_reviews_importer_areviews_title_rating"] .areviews_main_header_container > span');
    
    if ($el.length) {
      $el.each(function () {
        this.style.setProperty('display', 'flex', 'important');
      });
      clearInterval(interval); // stop checking once found
    }
  }, 300); // check every 300ms

})